var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThirdStageArabic = function SvgThirdStageArabic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.293 24.233a2.384 2.384 0 0 1-.096 3.392 2.4 2.4 0 1 1 0-3.392zm.277-1a3.399 3.399 0 1 0 .322 5.111 3.384 3.384 0 0 0 .123-4.802l-.295-.309zm1.847-1.125L13.694 6.417l-.001-.001a2.407 2.407 0 0 0-3.39.001l-4.218 4.218-.001.001a2.41 2.41 0 0 0 0 3.389h.001L21.776 29.75a5.403 5.403 0 0 0 7.641-7.64m-8.348 8.348a6.403 6.403 0 1 0 9.056-9.055L14.398 5.707a3.41 3.41 0 0 0-4.8 0L5.376 9.931a3.41 3.41 0 0 0 0 4.8z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.408 32.328A3.41 3.41 0 0 1 0 28.921v-5.984a3.41 3.41 0 0 1 3.408-3.408h6.735L21.07 30.457a6.4 6.4 0 0 0 4.517 1.872zm17.125-1H3.408A2.407 2.407 0 0 1 1 28.921v-5.984a2.41 2.41 0 0 1 2.408-2.408h6.32l10.635 10.635z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.996 3.74v22.19a5.4 5.4 0 0 1-10.799 0V3.74a2.407 2.407 0 0 1 2.408-2.408h5.983a2.41 2.41 0 0 1 2.408 2.408m-2 22.193a3.416 3.416 0 1 0-3.396 3.396h.003l-.006-1v1h.003a3.4 3.4 0 0 0 3.396-3.396m-1-.004h1v.007zm4 0V3.74A3.41 3.41 0 0 0 28.588.333h-5.983a3.407 3.407 0 0 0-3.408 3.408v22.19a6.4 6.4 0 1 0 12.799 0",
    clipRule: "evenodd"
  })));
};
export default SvgThirdStageArabic;